import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "src/i18n/locales/en.json";

// Bundled rather than fetched: one locale today. Switch to i18next-http-backend (as Builder does)
// once more locales make the bundle cost worth a request.
void i18n.use(initReactI18next).init({
	resources: { en: { translation: en } },
	lng: "en",
	fallbackLng: "en",
	interpolation: { escapeValue: false }
});

export default i18n;
